export default {
  discount_code_base_url: '/api/admin/discount-codes',
  store(form) {
    return form.post(this.discount_code_base_url);
  },

  update(form, id) {
    return form.put(`${this.discount_code_base_url}/${id}`);
  },
};